w<template>
  <div @keyup.enter.prevent="createPreset">
    <UiModal class="is-small" close-on-overlay @close="close">
      <template slot="header">
        <div class="modal-card-title">Сохранить пресет</div>
      </template>

      <template slot="content">
        <form-group :validator="$v.form.name" :server-errors="serverError('name')">
          <template slot-scope="{ attributes }">
            <UiInputText
              ref="name"
              v-model="form.name"
              placeholder="Название пресета"
              type="text"
              autocapitalize="off"
              autocorrect="off"
              :class="attributes.class"
            >
            </UiInputText>
          </template>
        </form-group>

        <div>
          Параметры пресета:
          <div v-if="queries.length <= 0">Список параметров пуст.</div>
          <div v-else>
            <div v-for="(q, i) in queries" :key="i"> {{ i + 1 }}. {{ q.key }} : {{ q.value }} </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <UiButton
          :class="['button', 'is-blue', 'is-outlined', { 'is-loading': tryCreate }]"
          :disabled="tryCreate"
          @click="createPreset"
        >
          Сохранить
        </UiButton>
      </template>
    </UiModal>
  </div>
</template>

<script>
import UiModal from '@/components/UiModal.vue'
import UiButton from '@/components/UiButton.vue'
import UiInputText from '@/components/UiInputText.vue'

import syncQuery from '@/mixins/syncUrlQuery'

import { PresetsService } from '@/services/presets.service'

import { required } from 'vuelidate/lib/validators'
import validationHelpers from '@/mixins/validationHelpers.js'

export default {
  components: { UiModal, UiButton, UiInputText },
  mixins: [syncQuery, validationHelpers],
  data() {
    return {
      tryCreate: false,
      form: {
        name: '',
      },
    }
  },
  validations: {
    form: {
      name: {
        required,
      },
    },
  },
  computed: {
    queries() {
      const keys = Object.keys(this.$query)
      if (keys <= 0) return []

      return keys.map((key) => {
        return {
          key,
          value: this.$query[key],
        }
      })
    },
  },
  methods: {
    async createPreset() {
      this.$v.$touch()
      this.clearFormServerErrors()

      if (this.$v.form.$invalid) return

      try {
        this.tryCreate = true

        await PresetsService.create({ name: this.form.name, dataset: JSON.stringify(this.$query) })

        this.tryCreate = false

        this.close()

        this.$store.commit('toast/NEW', { type: 'success', message: 'Пресет успешно сохранен.' })
      } catch (e) {
        this.$store.commit('toast/NEW', { type: 'error', message: e.message, e })

        this.formServerErrors = e.formServerErrors

        this.error = e.message
      } finally {
        this.tryCreate = false
      }
    },

    close() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.radio {
  margin: 0 0 10px 0;
}
</style>
